import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Else, If, Then } from '@edikk-edikk/if';
import { Button, ButtonContentWithLoader, ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useAdvertContactsState, useAdvertContactsVisibleControl } from '#advertContacts/hooks';
import { useMenuContext } from '#baseMenu/hooks';

const AdvertContactsToggleButton: FC = () => {
  const { isLoadInProcess } = useAdvertContactsState();
  const { hide: hideMenu, isOpen: isMenuOpen } = useMenuContext();
  const { isOpen, open, hide } = useAdvertContactsVisibleControl();

  const handlerClick = useCallback(() => {
    if (isMenuOpen) {
      hideMenu();
    }

    if (isOpen) {
      hide();
    } else {
      open();
    }
  }, [hide, hideMenu, isMenuOpen, isOpen, open]);

  return (
    <Button
      variant={isOpen ? ButtonVariant.white65 : ButtonVariant.black65}
      pill
      textUppercase
      onClick={handlerClick}
      additionalClassName="flex-grow-1"
    >
      <ButtonContentWithLoader
        isLoading={isLoadInProcess}
        content={(
          <If condition={isOpen}>
            <Then>
              <FormattedMessage defaultMessage="Close" />
            </Then>
            <Else>
              <FormattedMessage defaultMessage="Contacts" />
            </Else>
          </If>
        )}
      />
    </Button>
  );
};

export { AdvertContactsToggleButton };
